import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from '../reducers'
import thunk from 'redux-thunk'

/**
 * Factory function for creating the Redux store.
 *
 * @param {Function} [devtoolsCompose] - Optional Redux DevTools compose enhancer.
 *   Pass `window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__` on web.
 *   Omit (or pass undefined) on mobile/server.
 * @returns {import('redux').Store}
 */
export function createAppStore(devtoolsCompose) {
  const storeEnhancers = devtoolsCompose || compose
  return createStore(
    rootReducer,
    storeEnhancers(applyMiddleware(thunk))
  )
}
